export var sizes = {
  small: 740,
  medium: 1024,
  nav: 1150,
  large: 1440
};
export default (function (size) {
  if (size) {
    return "(min-width: ".concat(sizes[size], "px)");
  }

  return 'inherit';
});